import { useState } from "react"
import { RouteComponentProps } from "@reach/router"
import { ForgotPassword as ForgotPasswordUI } from "@shared/application-components"
import { FormRecords } from "@shared/primitive-components"
import { useAuth } from "../../contexts"

export const ForgotPassword: React.FC<RouteComponentProps> = () => {
  const [resetRequested, setResetRequested] = useState(false)
  const auth = useAuth()

  const resetPassword = async (email: string) => auth.resetPassword(email).then(() => setResetRequested(true))
  const onSubmit = async (values: FormRecords) => resetPassword(values.email.value)

  return <ForgotPasswordUI onSubmit={onSubmit} resetRequested={resetRequested} />
}
